<div class="vm-accordion__title-bar">
  <button
    type="button"
    class="vm-accordion__title-bar--toggle"
    [class.vm-accordion__title--active]="isActive"
    [attr.aria-expanded]="isActive"
    [attr.aria-controls]="titleId"
    (click)="toggle()"
  >
    <div class="vm-accordion__title-bar--main-wrapper">
      <div
        class="vm-accordion__title-bar--flex-wrapper"
        [ngClass]="subTitles?.length ? 'vm-accordion__title-bar--title' : ''"
      >
        <div class="vm-accordion__title-bar-left-icon">
          <i class="vm-accordion__title-bar--icon fa fa-fw" [ngClass]="classes" *ngIf="icon"></i>
          <img
            [src]="image"
            alt="Title icon"
            class="vm-accordion__title-bar--image"
            *ngIf="!icon && image"
            loading="lazy"
          />
        </div>
        <div class="vm-accordion__title-bar-content">
          <h3 class="vm-accordion__title-bar-h3-content">
            <ng-content></ng-content>
          </h3>
        </div>
      </div>

      <div
        *ngFor="let subTitleObj of subTitles"
        class="vm-accordion__title-bar--flex-wrapper vm-accordion__title-bar--sub-title"
      >
        <div class="vm-accordion__sub-title-left-icon">
          <i class="vm-accordion__title-bar--icon fa fa-fw" [ngClass]="subTitleObj.subTitleIconClass"></i>
        </div>
        <div class="vm-accordion__title-bar-content" *ngIf="subTitleObj.subTitle">
          <span
            [ngClass]="subTitleObj.subTitleClass"
            data-cy="subtitle"
            [innerHTML]="subTitleObj.subTitle | markdown"
          ></span>
        </div>
      </div>
    </div>

    <div class="vm-accordion__title-bar-right-icon" *ngIf="!contentDisabled">
      <i
        class="far fa-fw fa-chevron-down vm-accordion__title-bar--status"
        [class.vm-accordion__title-bar--status-active]="isActive"
      >
      </i>
    </div>
  </button>
</div>
